import React, { useState, useRef, useEffect } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import hero1 from "../../images/Slider_img-1.png";
import hero2 from "../../images/Rota-pg-Slide.png";
import { useLocation } from "react-router-dom";
import Call from "../../images/telephone.png";
import Email from "../../images/email.png";
import { Link } from "react-router-dom";
import "./Home.css";

const Card = ({ image, title, content, activeSection }) => {
  const navigate = useNavigate();
  const cardRef = useRef(null);

  const [transform, setTransform] = useState({
    rotateX: 0,
    rotateY: 0,
    translateX: 0,
    translateY: 0,
  });

  const handleMouseMove = (e) => {
    const card = cardRef.current;
    const rect = card.getBoundingClientRect();

    const mouseX = e.clientX - rect.left - rect.width / 2;
    const mouseY = e.clientY - rect.top - rect.height / 2;

    setTransform({
      rotateX: -(mouseY / rect.height) * 30,
      rotateY: (mouseX / rect.width) * 30,
      translateX: (mouseX / rect.width) * -40,
      translateY: (mouseY / rect.height) * -40,
    });
  };

  const resetCard = () => {
    setTransform({
      rotateX: 0,
      rotateY: 0,
      translateX: 0,
      translateY: 0,
    });
  };

  return (
    <div
      className="card-wrap"
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={resetCard}
    >
      <div
        className="card"
        style={{
          transform: `rotateY(${transform.rotateY}deg) rotateX(${transform.rotateX}deg)`,
        }}
      >
        <div
          className="card-bg"
          style={{
            backgroundImage: `url(${image})`,
            transform: `translateX(${transform.translateX}px) translateY(${transform.translateY}px)`,
          }}
        />

        <div className="card-info">
          <h1>{title}</h1>
          <p>{content}</p>
          <button
            className="card-btn"
            onClick={() => navigate("/services", { state: { activeSection } })}
          >
            Read More
          </button>
        </div>
      </div>
    </div>
  );
};

const slides = [
  {
    background: hero1,

    tag: "",

    title: (
      <>
        Expert guidance
        <br />
        for the <span>care sector</span>
      </>
    ),    
    titleStyle: {
      textAlign: "center",
      width: "100%",
      margin: "0 auto",
      display: "block",
      color: "#0F172A",
      fontSize: "7rem",
      fontWeight: "700",
      lineHeight: "1.2",
    },

    image: null,
    description:
      "Total Care Advisory provides specialist consultancy services for care providers, healthcare organisations, and social care businesses across the UK. We are dedicated to enhancing compliance, operational efficiency, financial performance, and overall quality of care.",
    descriptionClassName: "slide1-description",
    descriptionStyle: {
      color: "#475569",
      fontSize: "2rem",
      lineHeight: "1.6",
      textAlign: "center",
      maxWidth: "1700px",
      width: "100%",
      margin: "25px auto 0",
      display: "block",
    },

    buttons: [],
    feature: [],
  },
  {
    background: "#F6FBFF",

    tag: "BUILT FOR CARE PROVIDERS",
    tagClassName: "slide2-tag",
    tagStyle: {
      color: "#0F5EB8",
      background: "#DCEEFF",
      display: "inline-block",
      padding: "8px 16px",
      borderRadius: "20px",
      fontSize: "0.9rem",
      fontWeight: "700",
      letterSpacing: "1px",
      textTransform: "uppercase",
      marginTop: "70px",
      marginBottom: "28px",
    },

    title: (
      <>
        Smarter rotas. Lower
        <br /> costs. <span>Better care.</span>
      </>
    ),
    titleClassName: "slide2-title",
    titleStyle: {
      color: "#0F2B57",
      fontSize: "4.6rem",
      fontWeight: "800",
      lineHeight: "1.05",
      maxWidth: "720px", // Keeps title on exactly 2 lines
      marginBottom: "28px",
    },

    description:
      "Total Care Rota gives care homes and care providers one clear system for staffing, attendance, compliance, payroll-ready timesheets and workforce cost control.",
    descriptionClassName: "slide2-description",
    descriptionStyle: {
      color: "#5B6B82",
      fontSize: "1.2rem",
      lineHeight: "1.8",
      maxWidth: "700px",
      marginBottom: "20px",
    },

    image: hero2,

    imageStyle: {
      width: "100%",
      maxWidth: "650px",
      marginRight: "-90px", // Move image towards the right
      display: "block",
    },

    buttons: [
      {
        text: "Book Your Free Demo",
        className: "primary",
        link: "mailto:info@totalcareadvisory.co.uk?subject=Total%20Care%20Rota%20Demo",
      },
      {
        text: "Explore Features",
        className: "secondary",
        link: "/Sub-Pages/Soft_Rota",
      },
    ],

    feature: ["Care-sector focused", "Fast implementation", "Multi-site ready"],
  },
];
const Home = () => {
  const cards = [
    {
      image:
        "https://primary.jwwb.nl/pexels/19/19825346.jpeg?enable-io=true&crop=1.3333%3A1&width=532",
      title: "CQC Services",
      content:
        "Our expert consultants guide you through every stage of the Care Quality Commission (CQC) process, from registration and compliance to inspections and ongoing quality improvement. We help ensure your service meets regulatory standards with confidence.",
      activeSection: "cqc-services",
    },
    {
      image:
        "https://primary.jwwb.nl/pexels/78/7876379.jpeg?enable-io=true&crop=1.3333%3A1&width=532",
      title: "Care Home Sales",
      content:
        "Our Care Home Sales service provides expert guidance throughout the buying and selling process, helping owners maximise value, ensure compliance, and achieve smooth, confidential transactions with confidence and clarity.",
      activeSection: "care-home-sales",
    },
    {
      image:
        "https://plus.unsplash.com/premium_photo-1661761077411-d50cba031848",
      title: "Accounting",
      content:
        "Our specialist Accountancy Services for the care industry provide tailored financial support, helping providers manage finances efficiently, maintain compliance, improve profitability, and make informed decisions for sustainable long-term growth.",
      activeSection: "accounting",
    },
    {
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRnb9YuXBp_jzaE5AOlAteiGP5lsCWY7O8nfw&s",
      title: "Software",
      content:
        "Our care sector software solutions streamline scheduling, governance, auditing. Our full ERP system provides all-round efficiency to maintain compliance, enhance oversight, and deliver better outcomes across their organisations.",
      activeSection: "software",
    },
    {
      image:
        "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/care-staff-high.jpg?enable-io=true&crop=1.3324%3A1%2Coffset-x37&width=532",
      title: "Operational Management",
      content:
        "We deliver face-to-face training for care professionals, covering moving and handling, medication, fire safety, and first aid, helping teams build confidence, stay compliant, and deliver safe, high-quality care.",
      activeSection: "operational-management",
    },
  ];

  const members = [
    {
      name: "Walter Dzvairo",
      role: "Founder",
      image:
        "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/walter-high.jpg?enable-io=true&crop=1%3A1&width=226",
    },
    {
      name: "Gurvinder Singh",
      role: "Business Partner",
      image:
        "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/gurvinder-high.jpg?enable-io=true&crop=1%3A1&width=226",
    },
    {
      name: "Simon Kett",
      role: "Business Development ",
      image:
        "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/simon-standard.png?enable-io=true&crop=1%3A1&width=226",
    },
    {
      name: "David Hutchison",
      role: "Business Development ",
      image:
        "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/david-high.jpg?enable-io=true&crop=1%3A1&width=226",
    },
    {
      name: "Kieran Bloom",
      role: "Capital Allowances",
      image:
        "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/kieran-high.jpg?enable-io=true&crop=1%3A1&width=226",
    },
    {
      name: "Ebony Fletcher",
      role: "Recruitment",
      image:
        "https://primary.jwwb.nl/public/m/v/j/temp-eqjijjtghditaoxiqxzk/ebony-high.jpg?enable-io=true&crop=1%3A1&width=226",
    },
  ];
  const testimonials = [
    {
      text: `"Total Care Advisory's guidance was invaluable. Their practical experiences truly made a difference in navigating CQC regulations and optimising our service."`,
      author: "Stephen R, Home Care Director, Bristol.",
    },
    {
      text: `"The team provided outstanding support throughout our registration process. Their expertise helped us achieve compliance quickly and confidently."`,
      author: "Sarah M, Care Home Manager, London.",
    },
    {
      text: `"Professional, knowledgeable, and responsive. We would highly recommend their consultancy services to any care provider."`,
      author: "James T, Registered Manager, Manchester.",
    },
  ];

  const [active, setActive] = useState(0);
  const nextSlide = () => {
    setActive((prev) => (prev + 1) % members.length);
  };
  const prevSlide = () => {
    setActive((prev) => (prev - 1 + members.length) % members.length);
  };

  const [current, setCurrent] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (isHovered) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [isHovered]);

  // contact //
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollToContact) {
      document.getElementById("ContactUs")?.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, [location]);

  const [showPopup, setShowPopup] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    const response = await fetch(
      "https://formsubmit.co/ajax/info@totalcareadvisory.com",
      {
        method: "POST",
        body: formData,
      },
    );

    if (response.ok) {
      setShowPopup(true);
      e.target.reset();

      setTimeout(() => {
        setShowPopup(false);
      }, 3000);
    }
  };

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 7000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* section slider */}
      <section className="slider">
        <div
          className="track"
          style={{
            transform: `translateX(-${currentSlide * 100}%)`,
          }}
        >
          {slides.map((slide, index) => (
            <section
              key={index}
              className="slide"
              style={{
                background: slide.background.startsWith("#")
                  ? slide.background
                  : `url(${slide.background}) center/cover no-repeat`,
              }}
            >
              {/* Merged Content Section */}
              <div
                className={`content ${slide.image ? "content-split" : "content-center"}`}
              >
                <div className="left">
                  {slide.tag && <div className="tag">{slide.tag}</div>}

                  <h1 style={slide.titleStyle}>{slide.title}</h1>

                  <p style={slide.descriptionStyle}>{slide.description}</p>

                  {slide.buttons.length > 0 && (
                    <div className="buttons">
                      {slide.buttons.map((btn, i) => (
                        <Link key={i} to={btn.link}>
                          <button id="Slide-btn" className={btn.className}>{btn.text}</button>
                        </Link>
                      ))}
                    </div>
                  )}

                  {slide.feature.length > 0 && (
                    <div className="feature">
                      {slide.feature.map((item, i) => (
                        <span key={i}>✓ {item}</span>
                      ))}
                    </div>
                  )}
                </div>

                {slide.image && (
                  <div className="right">
                    <img src={slide.image} alt="Slide" />
                  </div>
                )}
              </div>
            </section>
          ))}
        </div>

        <button
          className="arrow leftArrow"
          onClick={() =>
            setCurrentSlide(
              currentSlide === 0 ? slides.length - 1 : currentSlide - 1,
            )
          }
        >
          ❮
        </button>

        <button
          className="arrow rightArrow"
          onClick={() => setCurrentSlide((currentSlide + 1) % slides.length)}
        >
          ❯
        </button>
        {/* Scroll Down Mouse Animation */}
        <div className="scroll-indicator">
          <div className="mouse">
            <span className="wheel"></span>
          </div>
          <span className="scroll-text">Scroll Down</span>
        </div>
      </section>
      {/* section Services */}
      <section className="Services">
        <h1 className="title">Our Tailored Services</h1>

        <div className="Services-container">
          {cards.map((card) => (
            <Card
              key={card.activeSection}
              image={card.image}
              title={card.title}
              content={card.content}
              activeSection={card.activeSection}
            />
          ))}
        </div>
      </section>

      <section
        className="home-testimonial"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="home-testimonial-content">
          <h2>{testimonials[current].text}</h2>

          <p>{testimonials[current].author}</p>
          <button className="Home-btn">
            <NavLink to="/insights">Read More</NavLink>
          </button>
        </div>
        <div className="slider-dots">
          {testimonials.map((_, index) => (
            <span
              key={index}
              className={`dots ${current === index ? "active" : ""}`}
              onClick={() => setCurrent(index)}
            />
          ))}
        </div>
      </section>

      {/* section Contact */}
      <section id="ContactUs" className="contact-section">
        <div className="contact-container">
          <div className="contact-left">
            <div className="overlay"></div>

            <h2>Contact Us</h2>

            <div className="contact-card">
              <div className="contact-item">
                <img src={Call} alt="Phone" />
                <span>+44 16033203325</span>
              </div>

              <div className="contact-item">
                <img src={Email} alt="Email" />
                <span>Info@totalcareadvisory.com</span>
              </div>
            </div>
          </div>
          <div className="contact-right">
            <h2>Contact Us</h2>
            <form className="contact-form" onSubmit={handleSubmit}>
              <input type="text" name="Name" placeholder="Name" required />

              <input type="email" name="Email" placeholder="Email" required />

              <input type="tel" name="Phone" placeholder="Phone No." required />

              <textarea
                name="Message"
                placeholder="Message"
                rows="5"
                required
              />

              <button className="animated-btn" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      </section>

      {showPopup && (
        <div className="popup">
          <div className="popup-content">
            <h3>✓ Message Sent</h3>
            <p>Your enquiry has been submitted successfully.</p>
          </div>
        </div>
      )}
    </>
  );
};

export default Home;
